// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popper-address-help-tag{background:#000;border:none;border-radius:4px;color:#fff;font-size:12px;line-height:1.5em;padding:10px 10px 8px}.popper-address-help-tag .popper__arrow:after{border-top-color:#000!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
